import { createFileRoute, notFound } from "@tanstack/react-router";
import { UkCitySlugRoute } from "@/pages/CitySlugRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/$ukCitySlug/")({
  beforeLoad: ({ params }) => {
    if (!params.ukCitySlug?.startsWith("used-cars-")) throw notFound();
  },
  head: ({ params }) => routeHead("/uk/$ukCitySlug/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UkCitySlugRoute />
  );
}
